var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', {
    ref: "container",
    staticClass: "grey-f7",
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_vm.initiated ? [_vm.type == _vm.LECTURE_VIDEO_TYPES.UTUBE.value ? [_c('video-utube', _vm._b({}, 'video-utube', {
    width: _vm.width,
    height: _vm.height
  }, false))] : _vm._e(), _vm.type == _vm.LECTURE_VIDEO_TYPES.VIMEO.value ? [_c('video-vimeo', _vm._b({}, 'video-vimeo', {
    width: _vm.width,
    height: _vm.height
  }, false))] : _vm._e()] : _vm._e(), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.initiated,
      expression: "!initiated"
    }],
    attrs: {
      "absolute": "",
      "color": "transparent"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }